export default "__VITE_ASSET__B6qErqva__"